<template>
    <div class="d-flex flex-grow-1 flex-column align-items-center justify-content-center card my-0 py-5 px-4">
        <i class="mdi mdi-qrcode-scan" style="font-size: 80px;" :style="{ color: color.primary }"></i>
        <h3 class="mt-4 text-center">{{ $t('content.attendance.student_title') }}</h3>
        <p class="text-muted text-center mt-2">{{ $t('content.attendance.student_message') }}</p>
        <div v-if="completed" class="mt-3 alert alert-success text-center">
            <i class="mdi mdi-check-circle mr-2"></i>
            {{ $t('content.attendance.student_completed') }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'AttendanceContent',

    props: {
        contentId: Number,
    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        completed() {
            const list = this.$store.getters.LOADED_LIST_CONTENT;
            if (!list || !list.data) return false;
            const item = list.data.find(c => c.id === this.contentId);
            return item ? !!item.completed : false;
        },
    },
};
</script>
